import { createElement } from 'react';
import { store } from '../store';
import { observer } from 'mobx-react';
import { ComponentsList } from './';
import flowRight from 'lodash.flowright';
import withStyles, { WithStyles } from 'react-jss';
import PageSettings from './PageSettings';
import { cpus } from 'os';
import ColumnSettings from './ColumnSettings';

const backbutton = require('../components/icons/backbutton.svg');

const styles = {
    leftPanel: {
        //flexBasis: 230,
        //backgroundColor: '#2F343E',
        backgroundColor: '#F2F2F5',
        maxHeight: 'calc(100vh)',
        maxWidth: 'calc(100wh)',
        overflowY: 'auto',
        color: '#CDCED1',
    },
    button: {
        margin: 50,
    },
};

interface IProps extends WithStyles<typeof styles> {}

const component: React.FunctionComponent<IProps> = ({ classes }) => {
    let C = store.leftPanelComponent;
    console.log('right panel', store.leftPanelComponentDescriptor);
    return (
        <div
            className={classes.leftPanel}
            style={{
                flexBasis: store.isSettingsOpen ? 325 : 220,
            }}>
            {store.ui.left_panel_view === 'component' || store.ui.left_panel_view === 'column' ? (
                <ComponentsList type={store.ui.left_panel_view} />
            ) : store.ui.left_panel_view === 'page_settings' ? (
                ((store.ui.onHover = false),
                (
                    <div>
                        <div>
                            <button
                                style={{
                                    float: 'right',
                                    width: 70,
                                    height: 30,
                                    backgroundColor: '#20d29f',
                                    color: '#FFFFFF',
                                    textTransform: 'uppercase',
                                    borderRadius: 2,
                                    opacity: 1,
                                    marginTop: -1,
                                    marginRight: 10,
                                    border: '1px solid #20d29f',
                                    '&:hover': {
                                        backgroundColor: '#20d29f',
                                    },
                                }}
                                onClick={(e) => {
                                    store.selectComponent(null);
                                    store.ui.onHover = true;
                                }}>
                                Done
                            </button>
                        </div>
                        <PageSettings />
                    </div>
                ))
            ) : store.ui.left_panel_view === 'settings' ? (
                ((store.ui.prev_view = 'component'),
                (store.ui.onHover = false),
                C ? (
                    <div>
                        <div
                            style={{
                                color: 'black',
                                fontSize: '12px',
                                padding: 12,
                                fontWeight: 600,
                            }}>
                            {store.leftPanelComponentDescriptor.name}
                            <button
                                style={{
                                    float: 'right',
                                    width: 70,
                                    height: 30,
                                    backgroundColor: '#20d29f',
                                    color: '#FFFFFF',
                                    textTransform: 'uppercase',
                                    borderRadius: 2,
                                    opacity: 1,
                                    padding: 5,
                                    marginTop: -6,
                                    border: '1px solid #20d29f',
                                    '&:hover': {
                                        backgroundColor: '#20d29f',
                                    },
                                }}
                                onClick={(e) => {
                                    store.selectComponent(null);
                                    store.ui.onHover = true;
                                }}>
                                Done
                            </button>
                        </div>
                        <div style={{ margin: '0 auto' }}>
                            <C descriptor={store.leftPanelComponentDescriptor} />
                        </div>
                    </div>
                ) : null)
            ) : store.ui.left_panel_view === 'column_settings' ? (
                ((store.ui.prev_view = 'column'),
                (store.ui.onHover = false),
                (
                    <div>
                        <div>
                            <button
                                style={{
                                    float: 'right',
                                    width: 70,
                                    height: 30,
                                    backgroundColor: '#20d29f',
                                    color: '#FFFFFF',
                                    textTransform: 'uppercase',
                                    borderRadius: 2,
                                    opacity: 1,
                                    marginTop: -6,
                                    marginRight: 8,
                                    border: '1px solid #20d29f',
                                    '&:hover': {
                                        backgroundColor: '#20d29f',
                                    },
                                }}
                                onClick={(e) => {
                                    store.selectComponent(null);
                                    store.ui.onHover = true;
                                }}>
                                Done
                            </button>
                        </div>
                        <ColumnSettings row={store.selectedRow} />
                    </div>
                ))
            ) : null}
        </div>
    );
};

export default flowRight([withStyles(styles), observer])(component);
